<template>
  <rounded-bar
    :chartdata="timeEntriesChartdata"
    :options="timeEntriesChartOptions"
    v-bind="$attrs"
  />
</template>

<script>
  import RoundedBar from 'components/Charts/RoundedBar.vue'
  import parseDate from 'date-fns/parse'
  import { secondsToHumanReadable } from 'src/utils/format'

  export default {
    components: {
      RoundedBar
    },
    props: {
      timeEntriesStatisticsData: {
        type: Array,
        requitred: true
      },
      timeUnit: {
        type: String,
        required: false,
        default: 'day'
      }
    },
    computed: {
      timeEntriesChartdata () {
        return {
          datasets: [{
            label: this.$tc('expense', 2),
            data: this.timeEntriesStatisticsData.map((entry) => ({ x: parseDate(entry.start_date), y: entry.value })),
            backgroundColor: '#4c51bf',
            hoverBackgroundColor: '#434190',
            maxBarThickness: 25,
            minBarLength: 3
          }]
        }
      },
      timeEntriesChartOptions () {
        return {
          layout: {
            padding: {
              left: 10,
              top: 10,
              right: 10,
              bottom: 10
            }
          },
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return `${secondsToHumanReadable(tooltipItem.yLabel)} h`
              }
            },
            displayColors: false
          },
          scales: {
            yAxes: [{
              display: 'auto',
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
                color: '#cbd5e0',
                zeroLineColor: '#cbd5e0',
                drawBorder: false,
                drawTicks: false
              },
              ticks: {
                callback: (value) => `${value / 3600} h`,
                stepSize: 3600,
                suggestedMin: 0,
                fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontColor: '#718096',
                padding: 15
              }
            }],
            xAxes: [{
              display: 'auto',
              offset: true,
              type: 'time',
              time: {
                unit: this.timeUnit,
                distribution: 'series',
                displayFormats: {
                  day: this.$t('date_format')
                },
                tooltipFormat: this.$t('date_format')
              },
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
                color: '#cbd5e0',
                zeroLineColor: '#cbd5e0',
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false
              },
              ticks: {
                autoSkipPadding: 20,
                fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontColor: '#718096',
                padding: 15
              }
            }]
          }
        }
      }
    }
  }
</script>
